import { PrismicNextLink } from '@prismicio/next';
import type { LinkField } from '@prismicio/client';
import { ArrowRightIcon } from '@/assets';

type Props = {
  field?: LinkField;
  label: string;
  className?: string;
};

const COMPACT_OVERRIDES = '!inline-flex w-fit !px-5 !py-2.5 !text-[14px]';

export function GreenCtaLink({ field, label, className }: Props) {
  const base = `primary-button ${COMPACT_OVERRIDES}`;
  const composed = className ? `${base} ${className}` : base;

  const content = (
    <>
      <ArrowRightIcon className="arrow-icon" />
      <span>{label}</span>
    </>
  );

  if (!field) {
    return <span className={composed}>{content}</span>;
  }

  return (
    <PrismicNextLink field={field} className={composed}>
      {content}
    </PrismicNextLink>
  );
}
